<template>
	<b-modal ref="exit-modal" title="Exit Scenario" v-model="exit_dialog" class="">

		<div style="min-height: 40px">
			<transition name="fade">
				<div v-if="save_selected==false" key="1">
					<div class="container" style="position: absolute">
						<p>Are you sure you want to exit?</p>
					</div>

				</div>
				<div v-else key="2">
					<b-form inline>
						<label class="mr-sm-2" for="saveName">Rename</label>
						<b-input class="mb-2 mr-sm-2 mb-sm-0 w-75" id="saveName" v-model="save_name" />
					</b-form>
				</div>
			</transition>

		</div>


		<div slot="modal-footer" class="w-100">
			<button type="button" class="btn btn-dark float-left" @click="cancelAction">Cancel</button>

			<button  type="button" class="btn btn-primary float-right" @click="saveAction">Save and exit</button>

			<transition name="fade">
				<button type="button" v-if="save_selected==false" class="btn btn-secondary float-right mr-1 ml-1" @click="exit">Exit without save</button>
			</transition>
		</div>



	</b-modal>
</template>
<script>

	export default {
		name: 'ExitDialog',
		data() {
			return {
				save_selected: false,
				save_name: null,
			}
		},
		computed: {
			exit_dialog: {
				get() { return this.$store.state.exit_dialog },
				set(value) { this.$store.commit('setState', ['exit_dialog', value])}
			},
			location() { return this.$store.state.location }
		},
		mounted() {
			this.save_name = this.$store.state.save_file ? this.$store.state.save_file : this.location.title + ' ' + this.moment().format('M.D.YY');
		},
		methods: {
			saveAction() {

				if (!this.save_selected) {
					this.save_selected = true;
					return;
				}

				this.$store.dispatch('save', {save_name: this.save_name });
				window.location.reload(true);
			},
			cancelAction() {
				this.exit_dialog = false;
				this.save_selected = false;
			},
			exit() {
				window.location.reload(true);
			}
		}
	}
</script>
